import { useEffect, useState } from "react"
import { Redirect } from 'react-router-dom'

export default function Home(props) {
    const [isBusy, setIsBusy] = useState(true)
    const [loggedIn, setLoggedIn] = useState(true)
    const [user, setUser] = useState(null)


    const getUserInfo = async () => {
        const queryResult = await fetch(`${process.env.REACT_APP_API_URL}/user/info`, {
            credentials: 'include'
        })
        if (queryResult.status === 401) {
            setLoggedIn(false)
        } else {
            const queryResultJSON = await queryResult.json()
            setUser(queryResultJSON)
        }
        setIsBusy(false)
    }

    useEffect(() => {
        getUserInfo()
    }, [])
    if (isBusy) {
        // Maybe make this a loading screen
        return (
            <div className='home'></div>
        )
    } else {
        if (loggedIn) {
            if(user.confirmed===false){
                return(
                    <div className='home'>
                        You should have been sent an email for confirmation<br />
                        Please confirm your email!
                    </div>
                )
            }
            return (
                <div className='home'>
                    Welcome to Finio, {user.first_name}
                </div>
            )
        } else {
            return (
                <Redirect to='/' />
            )
        }
    }
}